var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRedshift = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2976 27.5253L31.9876 30.7848V5.14258L18.2976 8.40209V27.5253Z",
    fill: "#205B97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9876 5.14258L34.5952 6.44638V29.481L31.9876 30.7848V5.14258ZM18.2976 27.5253L4.60767 30.7848V5.14258L18.2976 8.40209V27.5253Z",
    fill: "#5193CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60761 5.14258L2 6.44638V29.481L4.60761 30.7848V5.14258Z",
    fill: "#205B97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7751 36L26.9903 33.3924V2.60761L21.7751 0L20.1807 17.0948L21.7751 36Z",
    fill: "#5193CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8202 36L9.60498 33.3924V2.60761L14.8202 0L16.4146 17.0948L14.8202 36Z",
    fill: "#205B97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8201 0H21.8457V35.9273H14.8201V0Z",
    fill: "#2E73B7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRedshift);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/redshift.752342438a8cefe08480d151ff5a2d94.svg";